module.exports = __webpack_public_path__ + "static/sp_silo_thumbnail-39c53fb5fc1b7d1718041d44a37e9f3d.jpg";